// allows retrieval from Redux
export const mapStatetoProps = (state) => ({
  ...state.loginInfo,
});
